import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import NumberFormat from "react-number-format";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDBox from "components/MDBox";

const CooperatedFormIncome = ({ label, income, setIncome }) => {
  const [step, setStep] = useState(false);

  return (
    <Accordion
      expanded={step}
      onChange={() => setStep(!step)}
      slotProps={{ transition: { timeout: 400 } }}
      sx={{
        "& .MuiAccordion-region": {
          height: step ? "auto" : 0,
        },
        "& .MuiAccordionDetails-root": {
          display: step ? "block" : "none",
        },
      }}
    >
      <MDBox p={3}>
        <MDBox>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography>{label}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MDBox mt={1.625}>
              <div
                style={{
                  fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
                  fontWeight: "400",
                  lineHeight: "1.4375em",
                  letterSpacing: "0.00938em",
                  boxSizing: "border-box",
                  cursor: "text",
                  display: "inline-flex",
                  WebkitBoxAlign: "center",
                  alignItems: "center",
                  width: "100%",
                  position: "relative",
                  fontSize: "0.875rem",
                  color: "#344767",
                }}
              >
                <NumberFormat
                  label="Renda"
                  style={{
                    font: "inherit",
                    letterSpacing: "inherit",
                    color: "currentColor",
                    padding: "4px 0 5px",
                    border: "0",
                    boxSizing: "content-box",
                    background: "none",
                    height: "1.4375em",
                    margin: "0",
                    WebkitTapHighlightColor: "transparent",
                    display: "block",
                    minWidth: "0",
                    width: "100%",
                    animationName: "mui-auto-fill-cancel",
                    animationDuration: "10ms",
                    borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                    borderColor: "#d2d6da",
                  }}
                  prefix={"R$ "}
                  thousandSeparator="."
                  decimalSeparator=","
                  defaultValue="0,00"
                  value={income}
                  onValueChange={(e) => setIncome(e.formattedValue)}
                />
              </div>
            </MDBox>
          </AccordionDetails>
        </MDBox>
      </MDBox>
    </Accordion>
  );
};

export default CooperatedFormIncome;
